/* Marie Bags (GL3c, B136): gedrag van de productpagina, eigen code naar het gedrag van de bron.
   Maatkeuze en variant, galerij, maatgids (inch/cm), sticky balk, "Add another one" met tabbladen en pagina's.
   Naar de wagen gaat alles via window.mbCart (mb-cap.js): die bewaakt het maximum per bestelling. */
(function () {
  'use strict';

  // Maatreeksen van de bron (code, naam, maat in inch, "good for"). Bij tassen staat de maat in de optiewaarde;
  // bij manden niet, daar komt hij uit deze tabel.
  var RANGES = {
    artisanal: { title: 'Artisanal Quilted Bags', order: 'Width × height', measure: ', measured flat.',
      foot: 'Measured flat across the outside of the bag, handles excluded. Centimetres are converted from inches and rounded to the nearest half centimetre. Sizes can vary slightly, so allow a little either way.',
      notes: { S: 'Everyday shoulder bag', L: 'Roomier, for fuller days' } },
    beach: { title: 'Beach Bags', order: 'Width × height × depth', measure: ', measured flat.',
      foot: 'Measured flat across the outside of the bag, handles excluded. Centimetres are converted from inches and rounded to the nearest half centimetre. Sizes can vary slightly, so allow a little either way.',
      notes: { S: 'Towel, book, sunscreen', L: 'A family beach day' } },
    tote: { title: 'Quilted Tote Bags', order: 'Width × height', measure: ', measured flat.',
      foot: 'Measured flat across the outside of the bag, handles excluded. Centimetres are converted from inches and rounded to the nearest half centimetre. Sizes can vary slightly, so allow a little either way.',
      notes: { Wide: 'Wider opening, sits low', Tall: 'Narrower, stands taller' } },
    basket: { title: 'Quilted Laundry Baskets', order: 'Diameter × height', measure: ', measured across the outside.',
      foot: 'Measured across the outside of the basket, handles excluded. Centimetres are converted from inches and rounded to the nearest half centimetre. Sizes can vary slightly, so allow a little either way.',
      notes: { S: 'Bathroom, nursery or studio', M: 'Bedroom or laundry room', L: 'Family laundry and bedding' },
      dims: { S: [14, 18], M: [16, 22], L: [20, 28] } },
    duffle: { title: 'Quilted Duffle Bags', order: 'Width × height × depth', measure: ', measured flat.',
      foot: 'Measured across the outside of the bag, handles excluded. Centimetres are converted from inches and rounded to the nearest half centimetre. Sizes can vary slightly, so allow a little either way.',
      notes: {} },
    makeup: { title: 'Quilted Makeup Bags', order: 'Width × height × depth', measure: ', measured flat.',
      foot: 'Measured across the outside of the bag. Centimetres are converted from inches and rounded to the nearest half centimetre. Sizes can vary slightly, so allow a little either way.',
      notes: {} }
  };
  var NAMES = { S: 'Small', M: 'Medium', L: 'Large', Wide: 'Wide', Tall: 'Tall' };

  function cm(inch) { return Math.round(inch * 2.54 * 2) / 2; }
  function fmtN(n) { return String(n).replace(/\.0$/, ''); }

  function rangeFor(type, values) {
    var t = (type || '').toLowerCase(), v = values.join(' ').toLowerCase();
    if (t.indexOf('basket') > -1) return 'basket';
    if (t.indexOf('tote') > -1) return 'tote';
    if (t.indexOf('duffle') > -1) return 'duffle';
    if (t.indexOf('makeup') > -1) return 'makeup';
    if (/\d\s*[x×]\s*[\d.]+\s*[x×]\s*[\d.]+/.test(v)) return 'beach';
    if (/in\s*x|"\s*x|[\d.]+\s*in\b/.test(v)) return 'artisanal';
    return null;
  }

  // inchmaat uit een optiewaarde: "(15 in x 14 in)", "Short Bag (15\"x14\")", "16 x 16 x 6.5 inches",
  // "Medium (16 x 8 x 8 inches)", "(38 cm x 35 cm)/(15 in x 13.78 in)"
  function dimsFrom(value) {
    var s = String(value);
    if (/cm/i.test(s) && s.indexOf('/') > -1) s = s.split('/').pop();
    var m = s.match(/\d+(?:\.\d+)?/g);
    if (!m || m.length < 2) return null;
    return m.slice(0, 3).map(function (x) { return Math.round(parseFloat(x) * 2) / 2; });
  }

  function sizeModel(data, sizeIdx, codes) {
    var values = data.options[sizeIdx] ? valuesOf(data, sizeIdx) : [];
    var key = rangeFor(data.type, values);
    if (!key) return null;
    var r = RANGES[key];
    var sizes = values.map(function (val, i) {
      var code = codes[val] || val;
      var d = (r.dims && r.dims[code]) || dimsFrom(val);
      return { value: val, code: code, name: NAMES[code] || code, d: d, note: r.notes[code] || '' };
    }).filter(function (s) { return s.d; });
    if (!sizes.length) return null;
    return { key: key, r: r, sizes: sizes };
  }

  function valuesOf(data, idx) {
    var seen = {}, out = [];
    data.variants.forEach(function (v) {
      var x = v.options[idx];
      if (!seen[x]) { seen[x] = 1; out.push(x); }
    });
    return out;
  }

  function dimText(d, unit) {
    var a = d.map(function (x) { return unit === 'cm' ? fmtN(cm(x)) : fmtN(x); });
    return a.join(' × ') + (unit === 'cm' ? ' cm' : ' in');
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    var parts = v.split('.');
    var thousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}')
      .replace('{{amount_no_decimals}}', thousands)
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount}}', thousands + '.' + parts[1]);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function businessDays(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function addToCart(items, btn) {
    if (!window.mbCart) return Promise.reject(new Error('no cart'));
    return window.mbCart.add(items, { open: true, from: btn });
  }

  function initPdp(root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-mb-pdp-json]').textContent); } catch (e) { return; }
    var fmt = root.getAttribute('data-money-format') || window.mbMoneyFormat || '${{amount}}';
    var form = root.querySelector('[data-mb-form]');
    var vidInput = root.querySelector('[data-mb-vid]');
    var atc = root.querySelector('[data-mb-atc]');
    var atcLabel = root.querySelector('[data-mb-atc-label]');
    var err = root.querySelector('[data-mb-err]');
    var priceEl = root.querySelector('[data-mb-price]');
    var shipLine = root.querySelector('[data-mb-shipline]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-mb-opt]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.mb-pdp__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mb-thumb]'));
    var thumbsRow = root.querySelector('[data-mb-thumbs]');
    var sticky = root.querySelector('[data-mb-sticky]');

    // ---- galerij
    var cur = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-on'); }));
    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
      var t = thumbs[cur];
      if (t && thumbsRow) {
        var l = t.offsetLeft - thumbsRow.offsetLeft, w = thumbsRow.clientWidth;
        if (l < thumbsRow.scrollLeft || l + t.offsetWidth > thumbsRow.scrollLeft + w) {
          thumbsRow.scrollTo({ left: Math.max(0, l - (w - t.offsetWidth) / 2), behavior: 'smooth' });
        }
      }
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-mb-thumb'), 10)); });
    });
    root.querySelectorAll('[data-mb-tarr]').forEach(function (b) {
      b.addEventListener('click', function () { show(cur + parseInt(b.getAttribute('data-mb-tarr'), 10)); });
    });
    var main = root.querySelector('[data-mb-main]');
    if (main) {
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    // ---- varianten
    var sizeIdx = -1, codes = {};
    fieldsets.forEach(function (fs, i) {
      if ((fs.getAttribute('data-mb-optname') || '').toLowerCase() === 'size') sizeIdx = i;
    });
    if (sizeIdx > -1) {
      fieldsets[sizeIdx].querySelectorAll('input').forEach(function (inp) { codes[inp.value] = inp.getAttribute('data-mb-code'); });
    }
    var model = sizeIdx > -1 ? sizeModel(data, sizeIdx, codes) : null;

    function selected() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }
    function updateSizeLine() {
      var line = root.querySelector('[data-mb-sizeline]');
      if (!line || !model) return;
      var val = selected()[sizeIdx];
      var s = model.sizes.find(function (x) { return x.value === val; });
      line.innerHTML = s ? '<strong>' + esc(s.name) + '</strong> — ' + esc(dimText(s.d, 'cm')) + ' (' + esc(dimText(s.d, 'in')) + ')' : '';
    }
    function apply(v, push) {
      if (!v) {
        atc.disabled = true;
        atcLabel.textContent = 'Unavailable';
        return;
      }
      vidInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceEl) {
        var h = '';
        if (v.compare_at_price && v.compare_at_price > v.price) h += '<s class="mb-pdp__was">' + esc(money(v.compare_at_price, fmt)) + '</s>';
        h += v.price === 0 ? '<span class="mb-pdp__now mb-pdp__now--free">FREE</span>' : '<span class="mb-pdp__now">' + esc(money(v.price, fmt)) + '</span>';
        priceEl.innerHTML = h;
      }
      if (shipLine) shipLine.hidden = v.price !== 0;
      if (v.featured_media) {
        var k = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.featured_media.id); });
        if (k > -1) show(k);
      }
      if (push && window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      updateSizeLine();
      if (sticky) {
        sticky.querySelectorAll('[data-mb-sticky-opt]').forEach(function (sel) {
          var i = parseInt(sel.getAttribute('data-mb-sticky-opt'), 10);
          if (v.options[i] != null) sel.value = v.options[i];
        });
      }
    }
    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function (e) {
        if (!e.target.matches('input[type=radio]')) return;
        fs.querySelectorAll('.mb-pdp__val').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); });
        if (err) err.hidden = true;
        apply(findVariant(selected()), true);
      });
    });
    updateSizeLine();

    // ---- naar de wagen
    function submit(btn) {
      if (err) err.hidden = true;
      var id = parseInt(vidInput.value, 10);
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      addToCart([{ id: id, quantity: 1 }], btn)
        .catch(function (e) {
          if (err && e && e.message && e.message !== 'no cart') { err.textContent = e.message; err.hidden = false; }
          if (e && e.message === 'no cart') form.submit();
        })
        .then(function () { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); });
    }
    // Klik in plaats van submit: zo loopt de toevoeging altijd via mbCart (maximum en melding), ook als een andere
    // lade elk formulier naar /cart/add in de capture-fase onderschept.
    atc.addEventListener('click', function (e) { e.preventDefault(); if (!atc.disabled) submit(atc); });

    // ---- maatgids
    var chartBtn = root.querySelector('[data-mb-chart]');
    var sg = root.querySelector('[data-mb-sg]');
    var unit = 'in';
    function drawGuide() {
      if (!model || !sg) return;
      var val = selected()[sizeIdx];
      sg.querySelector('[data-mb-sg-title]').textContent = model.r.title;
      sg.querySelector('[data-mb-sg-order]').textContent = model.r.order + model.r.measure;
      sg.querySelector('[data-mb-sg-foot]').textContent = model.r.foot;
      var hasNote = model.sizes.some(function (s) { return s.note; });
      sg.querySelector('[data-mb-sg-notehead]').hidden = !hasNote;
      sg.querySelector('[data-mb-sg-body]').innerHTML = model.sizes.map(function (s) {
        return '<tr' + (s.value === val ? ' class="is-you"' : '') + '><td><b>' + esc(s.code) + '</b> ' + esc(s.name) +
          (s.value === val ? ' <span class="mb-sg__you">Selected</span>' : '') + '</td><td class="col-in">' + esc(dimText(s.d, 'in')) +
          '</td><td class="col-cm">' + esc(dimText(s.d, 'cm')) + '</td>' + (hasNote ? '<td class="col-note">' + esc(s.note) + '</td>' : '') + '</tr>';
      }).join('');
      // tekening op schaal: breedte x hoogte van elke maat naast elkaar
      var maxH = Math.max.apply(null, model.sizes.map(function (s) { return s.d[1]; }));
      var k = 150 / maxH, x = 10, parts = [];
      model.sizes.forEach(function (s) {
        var w = s.d[0] * k, h = s.d[1] * k, y = 170 - h;
        var on = s.value === val;
        parts.push('<g class="' + (on ? 'is-on' : '') + '"><rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="6"/>' +
          '<text x="' + (x + w / 2) + '" y="' + (y + h / 2 + 5) + '" text-anchor="middle" class="c">' + esc(s.code) + '</text>' +
          '<text x="' + (x + w / 2) + '" y="190" text-anchor="middle" class="m">' + esc(unit === 'cm' ? fmtN(cm(s.d[0])) + ' cm' : fmtN(s.d[0]) + ' in') + '</text></g>');
        x += w + 24;
      });
      sg.querySelector('[data-mb-sg-viz]').innerHTML = '<svg viewBox="0 0 ' + (x - 14) + ' 200" role="img" aria-label="Sizes drawn to scale">' + parts.join('') + '</svg>';
      sg.classList.toggle('is-cm', unit === 'cm');
      sg.querySelectorAll('[data-mb-sg-unit]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-mb-sg-unit') === unit); });
    }
    function openGuide() { drawGuide(); sg.hidden = false; document.documentElement.classList.add('mb-noscroll'); sg.querySelector('[data-mb-sg-close]').focus(); }
    function closeGuide() { sg.hidden = true; document.documentElement.classList.remove('mb-noscroll'); if (chartBtn) chartBtn.focus(); }
    if (chartBtn && model && sg) {
      chartBtn.hidden = false;
      chartBtn.addEventListener('click', openGuide);
      sg.addEventListener('click', function (e) {
        if (e.target === sg || e.target.closest('[data-mb-sg-close]')) closeGuide();
        var u = e.target.closest('[data-mb-sg-unit]');
        if (u) { unit = u.getAttribute('data-mb-sg-unit'); drawGuide(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sg.hidden) closeGuide(); });
    }
    // Size & Fit-accordeon: maatlijst uit hetzelfde model
    var sf = root.querySelector('[data-mb-sizefit]');
    if (sf && model) {
      var list = '<ul>' + model.sizes.map(function (s) {
        return '<li><strong>' + esc(s.code) + ' — ' + esc(s.name) + '</strong> — ' + esc(dimText(s.d, 'in')) + ' (' + esc(dimText(s.d, 'cm')) + ')</li>';
      }).join('') + '</ul>';
      sf.insertAdjacentHTML('beforeend', '<p>' + esc(model.r.order + model.r.measure) + '</p>' + list);
    }

    // ---- "Ships by"
    root.querySelectorAll('[data-mb-shipsby]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-mb-shipsby'), 10);
      if (n > 0) el.textContent = businessDays(n);
    });

    // ---- sticky balk
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var e = en[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        sticky.querySelectorAll('select,button').forEach(function (x) { x.tabIndex = past ? 0 : -1; });
      });
      io.observe(atc);
      sticky.querySelectorAll('[data-mb-sticky-opt]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var i = parseInt(sel.getAttribute('data-mb-sticky-opt'), 10);
          var fs = fieldsets[i];
          if (!fs) return;
          var inp = Array.prototype.find.call(fs.querySelectorAll('input'), function (x) { return x.value === sel.value; });
          if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
      var sb = sticky.querySelector('[data-mb-sticky-btn]');
      sb.addEventListener('click', function () { if (!atc.disabled) submit(sb); });
    }

    // ---- "Add another one"
    var up = root.querySelector('[data-mb-up]');
    if (up) {
      var per = parseInt(up.getAttribute('data-per'), 10) || 3;
      var tab = parseInt(up.getAttribute('data-start'), 10) || 0, page = 0;
      var panels = Array.prototype.slice.call(up.querySelectorAll('[data-mb-up-panel]'));
      var pg = up.querySelector('[data-mb-up-pg]');
      function draw() {
        panels.forEach(function (p, i) {
          p.hidden = i !== tab;
          if (i !== tab) return;
          var cards = Array.prototype.slice.call(p.querySelectorAll('.mb-up__card'));
          var pages = Math.max(1, Math.ceil(cards.length / per));
          page = (page + pages) % pages;
          cards.forEach(function (c, k) { c.hidden = Math.floor(k / per) !== page; });
          pg.textContent = (page + 1) + '/' + pages;
        });
        up.querySelectorAll('[data-mb-up-tab]').forEach(function (b, i) {
          b.classList.toggle('is-on', i === tab);
          b.setAttribute('aria-selected', i === tab ? 'true' : 'false');
        });
      }
      up.addEventListener('click', function (e) {
        var t = e.target.closest('[data-mb-up-tab]');
        if (t) { tab = parseInt(t.getAttribute('data-mb-up-tab'), 10); page = 0; draw(); return; }
        var a = e.target.closest('[data-mb-up-arr]');
        if (a) { page += parseInt(a.getAttribute('data-mb-up-arr'), 10); draw(); return; }
        var b = e.target.closest('[data-mb-up-add]');
        if (b && !b.disabled) {
          var card = b.closest('.mb-up__card');
          var sel = card && card.querySelector('[data-mb-up-sel]');
          var id = parseInt(sel ? sel.value : b.getAttribute('data-mb-up-add'), 10);
          b.disabled = true;
          var old = b.textContent;
          b.textContent = 'Adding';
          addToCart([{ id: id, quantity: 1 }], b)
            .then(function () { b.textContent = 'Added'; setTimeout(function () { b.textContent = old; b.disabled = false; syncCap(); }, 1600); })
            .catch(function () { b.textContent = old; b.disabled = false; syncCap(); });
        }
      });
      function syncCap() {
        var capped = !!(window.mbCart && window.mbCart.capped());
        up.querySelectorAll('[data-mb-up-add]').forEach(function (b) {
          if (b.textContent === 'Adding' || b.textContent === 'Added') return;
          b.disabled = capped;
          b.textContent = capped ? 'Limit' : 'Add';
        });
      }
      document.addEventListener('mb:cart', syncCap);
      draw();
      syncCap();
    }
  }

  function boot() { document.querySelectorAll('[data-mb-pdp]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
